import React from "react";
import { Box } from "@mui/material";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";
import TextInputField from "../common/TextInputField";
import CustomAutoComplete from "../common/CustomAutoComplete";

interface OptionalFieldSectionProps {
  title: string;
  placeholder?: string | null;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  maxLength?: number;
  type?: "text" | "list";
  options?: string[];
}

const OptionalFieldSection: React.FC<OptionalFieldSectionProps> = ({
  title,
  placeholder,
  value,
  onChange,
  maxLength = 100,
  type = "text",
  options = [],
}) => {
  const theme: Theme = useTheme();

  const handleListChange = (selectedValue: string | null) => {
    // Create a synthetic event object to match the expected onChange signature
    const syntheticEvent = {
      target: {
        value: selectedValue || "",
      },
    } as React.ChangeEvent<HTMLInputElement>;

    onChange(syntheticEvent);
  };

  const styles = {
    title: (theme: Theme) => ({
      color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
      fontFamily: "var(--font-Medium)",
      fontSize: "14px",
      lineHeight: "20px",
      flex: 1,
      marginBottom: "16px",
    }),
    subtitle: () => ({
      fontFamily: "var(--font-Regular)",
      fontSize: "12px",
      lineHeight: "16px",
    }),
  };

  return (
    <Box>
      <Box sx={styles.title(theme)}>
        {title} <span style={styles.subtitle()}>(Optional)</span>
      </Box>
      {type === "list" ? (
        <CustomAutoComplete
          placeholder={placeholder || undefined}
          options={options}
          value={value || null}
          onChange={handleListChange}
        />
      ) : (
        <TextInputField
          placeholder={placeholder || undefined}
          value={value}
          handleChange={onChange}
          name="placeholderInput"
          maxLength={maxLength}
          showCharacterCount={true}
        />
      )}
    </Box>
  );
};

export default OptionalFieldSection;